import uuid from 'uuid-random';

export const RECAPTCHA_POPUP_ID = uuid();
